export enum EvaluationTypeEnum {
  NOTEBOOK = "notebook",
  UPLOAD = "upload",
  HTML = "html",
  MONITORED_VM = "monitored_vm",
  MONITORED_UPLOAD = "monitored_upload",
}
